<span class="text" [ngClass]="{'selected': item.selected}" title="{{item.description}}" [innerHTML]="item.description | cpMark:searchTerms:markOperator.Contains"></span>
<div class="action" *ngIf="!item.selected">
	<cp-button-widget class="study-action-button add-button iconButton1" [button]="addItemButton" (onClick)="addItemHandler(item)"></cp-button-widget>
</div>
<div class="action" *ngIf="item.selected" [ngClass]="{'permanent' : alwaysShowRemove}">
	<cp-button-widget class="study-action-button remove-button iconButton1" [button]="removeItemButton" (onClick)="removeItemHandler(item)"></cp-button-widget>
</div>
